import React, { FC } from 'react';
import Link, { LinkProps } from 'next/link';

import { RSButtonAnchor, RSButtonAnchorProps } from '../RSButtonAnchor';
import { buildUrl } from 'src/utils/request-url';

export type RSButtonLinkProps = Omit<
  LinkProps,
  'passHref' | 'legacyBehavior'
> & {
  children?: RSButtonAnchorProps['children'];
  variant?: RSButtonAnchorProps['variant'];
  isBlock?: RSButtonAnchorProps['isBlock'];
  isDisabled?: RSButtonAnchorProps['isDisabled'];
};

export const RSButtonLink: FC<RSButtonLinkProps> = ({
  children,
  variant,
  isBlock,
  isDisabled,
  ...props
}) => {
  // Link互換(/reserveがあるなら削除する)再変換
  if (typeof props.href === 'string') props.href = buildUrl(props.href, 'next');
  if (props.href && typeof props.href === 'object' && props.href.pathname) {
    props.href.pathname = buildUrl(props.href.pathname, 'next');
  }
  return (
    <Link {...props} passHref legacyBehavior>
      <RSButtonAnchor
        variant={variant}
        isBlock={isBlock}
        isDisabled={isDisabled}
      >
        {children}
      </RSButtonAnchor>
    </Link>
  );
};
